import { Injectable } from "@angular/core";
import { IToast } from "@schema/toast";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ToastService {

  /**
   * A subject with an array of the current toasts that are relevant to the user
   */
  public toasts$: BehaviorSubject<IToast[]> = new BehaviorSubject([]);

  constructor() { }

  /**
   * Show a new toast
   */
  add(toast: IToast) {
    this.toasts$.next([...this.toasts$.getValue(), toast]);
  }

  /**
   * Remove an existing toast
   */
  remove(toast: IToast) {
    const toasts = this.toasts$.getValue().filter(t => t !== toast);
    this.toasts$.next(toasts);
  }
}
